import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import './LegalPolicy.css';
import './PageShell.css';

const CONTACT_EMAIL = 'support@oblitrok.com';
const WEBSITE_URL = 'https://oblitrok.com';
const LAST_UPDATED = {
  zh: '2026年8月9日',
  en: 'August 9, 2026',
};

const legalCopy = {
  zh: {
    languageLabel: '中文',
    otherPolicy: {
      terms: ['查看隐私政策', '/privacy-policy'],
      privacy: ['查看 Cookie 政策', '/cookie-policy'],
      cookie: ['查看隐私政策', '/privacy-policy'],
    },
    contactTitle: '隐私与合规联系',
    contactText: '如需查询、修改或删除个人信息，或对本政策有疑问，请通过邮箱联系我们。',
    backHome: '返回首页',
    effective: '最后更新',
    operator: '平台主体',
      policies: {
      terms: {
        title: '使用条款',
        subtitle: '本条款说明你在使用 Oblitrok 平台、账号、消息、支付、文件和服务协作功能时应遵守的规则。继续注册或登录，即表示你理解并同意这些条款。',
        sections: [
          {
            id: 'acceptance',
            title: '1. 接受条款',
            paragraphs: [
              `本使用条款适用于 Oblitrok 网站、移动端网页及其相关服务，网站地址为 ${WEBSITE_URL}。`,
              '通过访问、注册或使用 Oblitrok，即表示你已阅读、理解并同意遵守本条款、隐私政策以及平台不时发布的其他规则。若你不同意，请不要继续使用平台。',
            ],
          },
          {
            id: 'accounts',
            title: '2. 账号和资格',
            paragraphs: [
              '你应提供真实、完整、最新的账号信息，并妥善保管账号和密码。',
              '你对账号下的所有活动负责。若发现异常登录、账号被盗或安全风险，请立即通过平台支持渠道联系我们。',
            ],
          },
          {
            id: 'conduct',
            title: '3. 平台使用规则',
            paragraphs: [
              '你不得发布违法、欺诈、侵权、骚扰、歧视、虚假或误导性内容。',
              '你不得脱离平台进行违规引流、欺诈交易、恶意取消、刷单、虚假评价或破坏平台安全的行为。',
              '你应在沟通、交付、验收、评价和争议处理环节保持尊重和诚实。',
            ],
          },
          {
            id: 'payments',
            title: '4. 付款与结算',
            paragraphs: [
              '平台可能通过托管、自动结算、退款或争议流程处理订单资金。',
              '除非相关页面另有说明，付款、结算和退款规则以订单页面、支付页面和平台公告为准。',
            ],
          },
          {
            id: 'content',
            title: '5. 内容和知识产权',
            paragraphs: [
              '你对自己发布的内容负责，并授予平台为展示、存储、传输和运营服务所必需的使用权限。',
              '未经授权，不得复制、分发、反编译或滥用平台内容、代码、标识、商标或其他知识产权。',
            ],
          },
          {
            id: 'termination',
            title: '6. 终止与限制',
            paragraphs: [
              '若你违反条款、法律要求或平台规则，Oblitrok 可限制、暂停或终止账号访问权限。',
              '在适用法律允许范围内，我们也可能保留必要记录以处理争议、审计、合规或安全问题。',
            ],
          },
          {
            id: 'changes',
            title: '7. 条款更新',
            paragraphs: [
              '我们可能根据业务、技术或法律变化更新本条款。继续使用平台即表示你接受更新后的条款。',
              `如有问题，请联系 ${CONTACT_EMAIL}。`,
            ],
          },
        ],
      },
      privacy: {
        title: '隐私政策',
        subtitle: '本政策说明 Oblitrok 在提供技能服务、需求协作、消息沟通、文件上传和平台付款流程时如何处理个人信息。',
        sections: [
          {
            id: 'scope',
            title: '1. 适用范围',
            paragraphs: [
              `本隐私政策适用于 Oblitrok 网站、移动端网页及其相关服务，包括但不限于服务发布、需求发布、预约下单、站内消息、评价、钱包、自动支付记录、资料上传和客服支持。网站地址为 ${WEBSITE_URL}。`,
              '当你访问或使用 Oblitrok，即表示你已经阅读并理解本政策。若你不同意本政策，请停止使用相关服务。',
            ],
          },
          {
            id: 'collection',
            title: '2. 我们收集的信息',
            paragraphs: [
              '账号信息：用户名、邮箱、密码哈希、头像、个人简介、技能标签、通知语言和账户状态。',
              '服务与需求信息：你发布的服务、需求、报价、交稿、评论、评价、收藏、举报、预约和订单记录。',
              '沟通与交易信息：站内聊天内容、文件附件、付款申请、支付通知、交易编号、付款时间、订单状态和处理记录。',
              '技术与安全信息：IP 地址、设备与浏览器信息、访问时间、接口请求日志、登录令牌、本地语言偏好和必要的安全记录。',
              '客服与合规信息：你主动提交给客服或管理员的说明、截图、证明材料和处理记录。',
            ],
          },
          {
            id: 'use',
            title: '3. 我们如何使用信息',
            paragraphs: [
              '用于创建和维护账号、验证登录状态、展示个人资料、发布服务或需求、完成预约、交稿、评价和消息沟通。',
              '用于处理订单、托管付款、自动支付确认、结算记录、退款或争议处理。',
              '用于保障平台安全，包括身份验证、风控、反垃圾、违规内容处理、纠纷调查和审计记录。',
              '用于提供客服支持、发送必要通知、修复故障、改进页面体验和统计平台运行情况。',
              '除非获得你的同意或法律允许，我们不会将你的个人信息出售给第三方。',
            ],
          },
          {
            id: 'sharing',
            title: '4. 信息共享',
            paragraphs: [
              '为了完成服务协作，必要的资料会在交易相关方之间展示，例如用户名、头像、服务内容、需求内容、订单状态、交稿内容和评价。',
              '我们可能向云服务、对象存储、邮件、短信、支付、风控、数据备份等服务供应商共享必要信息，这些供应商只能在为 Oblitrok 提供服务的范围内处理信息。',
              '在法律法规、监管要求、司法程序、平台安全、权利保护或合并转让等必要场景下，我们可能依法披露相关信息。',
            ],
          },
          {
            id: 'retention',
            title: '5. 信息保存',
            paragraphs: [
              '我们会在实现本政策所述目的所需期间内保存个人信息。账号资料通常在账号有效期间保存；订单、付款、纠纷、审计和合规记录会按照业务、税务、争议处理或法律要求保留更长时间。',
              '当信息不再需要时，我们会删除、匿名化或限制访问。你也可以通过本页面提供的邮箱提出删除或更正请求。',
            ],
          },
          {
            id: 'security',
            title: '6. 信息安全',
            paragraphs: [
              '我们采取访问控制、密码哈希、传输加密、权限隔离、日志审计、上传限制和备份等措施保护信息安全。',
              '互联网传输和存储无法保证绝对安全。请妥善保管账号密码，不要在站外泄露验证码、交易记录或敏感资料。',
            ],
          },
          {
            id: 'rights',
            title: '7. 你的权利',
            paragraphs: [
              '在适用法律允许的范围内，你可以请求访问、更正、删除、导出或限制处理你的个人信息，也可以撤回非必要通知或营销类处理的同意。',
              `如需行使上述权利，请发送邮件至 ${CONTACT_EMAIL}。为保护账户安全，我们可能需要验证你的身份后再处理请求。`,
            ],
          },
          {
            id: 'minors',
            title: '8. 未成年人',
            paragraphs: [
              'Oblitrok 不面向未成年人单独注册和交易。未成年人相关的学习、陪练或线下服务应由监护人发起、确认并全程承担监护责任。',
            ],
          },
          {
            id: 'transfer',
            title: '9. 跨境处理',
            paragraphs: [
              'Oblitrok 使用的云服务、存储、邮件、短信或支付服务可能位于你所在地区以外。我们会根据适用法律采取合理措施保护跨境处理过程中的个人信息。',
            ],
          },
          {
            id: 'updates',
            title: '10. 政策更新与联系',
            paragraphs: [
              '我们可能根据业务、技术或法律变化更新本政策。重大变化会通过网站页面、站内通知或其他合理方式提示。',
              `如有隐私相关问题，请联系 ${CONTACT_EMAIL}。`,
            ],
          },
        ],
      },
      cookie: {
        title: 'Cookie 政策',
        subtitle: '本政策说明 Oblitrok 如何使用 Cookie、本地存储和类似技术来保持登录、保存偏好并提升网站安全性。',
        sections: [
          {
            id: 'what',
            title: '1. Cookie 和本地存储是什么',
            paragraphs: [
              'Cookie 是浏览器保存的小型文本数据。本地存储是浏览器提供的客户端存储能力。它们可以帮助网站记住登录状态、语言偏好、安全确认和页面设置。',
              'Oblitrok 当前主要使用必要类 Cookie 或本地存储来维持平台基础功能，不以出售个人信息为目的设置广告追踪 Cookie。',
            ],
          },
          {
            id: 'current',
            title: '2. 我们当前使用的项目',
            paragraphs: [
              '以下项目基于当前网站功能整理。实际使用情况可能随登录状态、浏览器设置和已启用的第三方服务而变化。',
            ],
            table: {
              columns: ['名称', '用途', '类型', '保存期限'],
              rows: [
                ['token', '保存登录令牌，用于识别登录用户并调用受保护接口。', 'localStorage', '退出登录或清除浏览器数据前'],
                ['language', '保存中英文语言偏好。', 'localStorage', '清除浏览器数据前'],
                ['remember_email', '在用户选择记住账号时保存登录邮箱，方便下次填写。', 'localStorage', '用户清除浏览器数据或覆盖前'],
                ['msg_safety_ack', '记录用户已阅读聊天安全提示，减少重复弹窗。', 'localStorage', '清除浏览器数据前'],
              ],
            },
          },
          {
            id: 'why',
            title: '3. 为什么使用这些技术',
            paragraphs: [
              '必要功能：保持登录状态、调用接口、提交表单、上传文件、发送消息和完成订单流程。',
              '偏好设置：保存语言、消息安全确认和少量页面状态，提升重复访问体验。',
              '安全与风控：辅助识别异常请求、保护账号安全、处理滥用、欺诈或争议。',
              '统计与改进：当网站启用分析服务时，可能使用聚合数据理解页面性能和访问质量。',
            ],
          },
          {
            id: 'third-party',
            title: '4. 第三方技术',
            paragraphs: [
              '当你使用文件上传、邮件、短信、支付、托管页面或云服务能力时，相关服务商可能按照其自身政策设置 Cookie 或类似技术。',
              '如果后续启用支付、数据分析或客服插件，Oblitrok 会按实际情况更新本政策或在页面中提供相应提示。',
            ],
          },
          {
            id: 'control',
            title: '5. 如何管理 Cookie',
            paragraphs: [
              '你可以通过浏览器设置删除或阻止 Cookie 和本地存储。阻止必要存储后，登录、消息、下单、上传、语言偏好等功能可能无法正常使用。',
              '你也可以退出登录并清除浏览器数据，或在账户设置中清理本地缓存。',
            ],
          },
          {
            id: 'updates',
            title: '6. 政策更新与联系',
            paragraphs: [
              `我们可能根据产品功能和第三方服务变化更新本 Cookie 政策。如有问题，请联系 ${CONTACT_EMAIL}。`,
            ],
          },
        ],
      },
    },
  },
  en: {
    languageLabel: 'English',
    otherPolicy: {
      terms: ['View Privacy Policy', '/privacy-policy'],
      privacy: ['View Cookie Policy', '/cookie-policy'],
      cookie: ['View Privacy Policy', '/privacy-policy'],
    },
    contactTitle: 'Privacy and Compliance Contact',
    contactText: 'For access, correction, deletion, or questions about this policy, contact us by email.',
    backHome: 'Back to Home',
    effective: 'Last updated',
    operator: 'Platform operator',
    policies: {
      terms: {
        title: 'Terms of Use',
        subtitle: 'These terms explain the rules for using Oblitrok accounts, services, tasks, messaging, files, payments, and collaboration workflows. By registering or signing in, you understand and agree to these terms.',
        sections: [
          {
            id: 'acceptance',
            title: '1. Acceptance',
            paragraphs: [
              `These Terms of Use apply to the Oblitrok website and related services. The website is ${WEBSITE_URL}.`,
              'By accessing, registering for, or using Oblitrok, you acknowledge that you have read, understood, and agree to these terms, the Privacy Policy, and other platform rules published from time to time. If you do not agree, do not continue using the platform.',
            ],
          },
          {
            id: 'accounts',
            title: '2. Accounts and Eligibility',
            paragraphs: [
              'You must provide accurate, complete, and current account information and keep your password secure.',
              'You are responsible for activity under your account. If you notice suspicious login activity, account takeover, or security risk, contact platform support promptly.',
            ],
          },
          {
            id: 'conduct',
            title: '3. Platform Conduct',
            paragraphs: [
              'You may not post illegal, fraudulent, infringing, harassing, discriminatory, false, or misleading content.',
              'You may not bypass platform workflows for abusive off-platform solicitation, fraudulent transactions, malicious cancellations, fake orders, fake reviews, or security attacks.',
              'You should act respectfully and honestly during messaging, delivery, acceptance, reviews, and dispute handling.',
            ],
          },
          {
            id: 'payments',
            title: '4. Payments and Settlement',
            paragraphs: [
              'The platform may support escrow-style workflows, automatic settlement, refunds, or dispute handling for orders.',
              'Unless a relevant page states otherwise, payment, settlement, and refund rules are governed by the order page, payment page, and platform notices.',
            ],
          },
          {
            id: 'content',
            title: '5. Content and Intellectual Property',
            paragraphs: [
              'You are responsible for content you publish and grant the platform the rights needed to display, store, transmit, and operate the services.',
              'You may not copy, distribute, reverse engineer, or misuse platform content, code, branding, trademarks, or other intellectual property without authorization.',
            ],
          },
          {
            id: 'termination',
            title: '6. Suspension and Termination',
            paragraphs: [
              'If you violate these terms, legal requirements, or platform rules, Oblitrok may restrict, suspend, or terminate account access.',
              'To the extent permitted by law, we may retain necessary records to handle disputes, audits, compliance, or safety issues.',
            ],
          },
          {
            id: 'changes',
            title: '7. Changes',
            paragraphs: [
              'We may update these terms when business, technical, or legal requirements change. Continued use of the platform means you accept the updated terms.',
              `For questions, contact ${CONTACT_EMAIL}.`,
            ],
          },
        ],
      },
      privacy: {
        title: 'Privacy Policy',
        subtitle: 'This policy explains how Oblitrok processes personal information when providing skill services, requirement collaboration, messaging, file uploads, and platform payment workflows.',
        sections: [
          {
            id: 'scope',
            title: '1. Scope',
            paragraphs: [
              `This Privacy Policy applies to the Oblitrok website and related services, including service listings, requirement postings, bookings, platform messaging, reviews, wallet records, automatic payment records, file uploads, and support. The website is ${WEBSITE_URL}.`,
              'By accessing or using Oblitrok, you acknowledge that you have read and understood this policy. If you do not agree, please stop using the services.',
            ],
          },
          {
            id: 'collection',
            title: '2. Information We Collect',
            paragraphs: [
              'Account information: username, email address, password hash, avatar, profile bio, skills, notification language, and account status.',
              'Service and requirement information: service listings, requirement details, proposals, submissions, comments, reviews, favorites, reports, bookings, and order records.',
              'Communication and transaction information: platform messages, attachments, checkout requests, payment notifications, transaction references, payment time, order status, and handling records.',
              'Technical and security information: IP address, device and browser data, access time, API logs, login tokens, language preference, and security records.',
              'Support and compliance information: descriptions, screenshots, proof materials, and handling records that you voluntarily provide to support or administrators.',
            ],
          },
          {
            id: 'use',
            title: '3. How We Use Information',
            paragraphs: [
              'We use information to create and maintain accounts, verify login status, display profiles, publish services or requirements, support bookings, submissions, reviews, and messaging.',
              'We use information to process orders, escrow-style workflows, automatic payment confirmation, settlement records, refunds, and disputes.',
              'We use information to protect platform safety, including authentication, risk control, anti-spam, content moderation, dispute investigation, and audit logs.',
              'We use information to provide support, send necessary notices, fix issues, improve the user experience, and understand platform operations.',
              'We do not sell your personal information to third parties unless you consent or applicable law permits it.',
            ],
          },
          {
            id: 'sharing',
            title: '4. Sharing Information',
            paragraphs: [
              'To complete service collaboration, necessary information may be shown to transaction participants, such as username, avatar, service content, requirement content, order status, submissions, and reviews.',
              'We may share necessary information with service providers for cloud hosting, object storage, email, SMS, payment, fraud prevention, and backups. They may process information only to provide services to Oblitrok.',
              'We may disclose information when required by law, regulation, legal process, platform safety needs, rights protection, or business transfer scenarios.',
            ],
          },
          {
            id: 'retention',
            title: '5. Retention',
            paragraphs: [
              'We retain personal information for as long as needed for the purposes described in this policy. Account data is usually retained while the account is active. Orders, payments, disputes, audit, and compliance records may be retained longer for business, tax, dispute resolution, or legal reasons.',
              'When information is no longer needed, we delete it, anonymize it, or restrict access. You may also request correction or deletion using the email on this page.',
            ],
          },
          {
            id: 'security',
            title: '6. Security',
            paragraphs: [
              'We use access controls, password hashing, encrypted transport, permission separation, audit logs, upload limits, and backups to help protect information.',
              'No internet transmission or storage method is completely secure. Keep your password safe and do not share verification codes, transaction records, or sensitive files outside the platform.',
            ],
          },
          {
            id: 'rights',
            title: '7. Your Rights',
            paragraphs: [
              'Subject to applicable law, you may request access, correction, deletion, export, or restriction of your personal information, and you may withdraw consent for non-essential notices or marketing processing.',
              `To exercise these rights, email ${CONTACT_EMAIL}. To protect your account, we may verify your identity before processing the request.`,
            ],
          },
          {
            id: 'minors',
            title: '8. Minors',
            paragraphs: [
              'Oblitrok is not intended for minors to register and transact independently. Learning, tutoring, or offline services involving minors should be initiated, confirmed, and supervised by a guardian.',
            ],
          },
          {
            id: 'transfer',
            title: '9. International Processing',
            paragraphs: [
              'Cloud hosting, storage, email, SMS, or payment services used by Oblitrok may be located outside your region. We take reasonable measures required by applicable law to protect information during cross-border processing.',
            ],
          },
          {
            id: 'updates',
            title: '10. Updates and Contact',
            paragraphs: [
              'We may update this policy when our business, technology, or legal requirements change. Material changes may be announced on the website, through in-app notices, or by other reasonable means.',
              `For privacy questions, contact ${CONTACT_EMAIL}.`,
            ],
          },
        ],
      },
      cookie: {
        title: 'Cookie Policy',
        subtitle: 'This policy explains how Oblitrok uses cookies, local storage, and similar technologies to keep users signed in, remember preferences, and improve website safety.',
        sections: [
          {
            id: 'what',
            title: '1. What Cookies and Local Storage Are',
            paragraphs: [
              'Cookies are small text files stored by your browser. Local storage is a browser-based storage feature. They help websites remember login status, language preferences, safety acknowledgements, and page settings.',
              'Oblitrok currently uses mainly essential cookies or local storage for core platform functionality. We do not set advertising tracking cookies for the purpose of selling personal information.',
            ],
          },
          {
            id: 'current',
            title: '2. What We Currently Use',
            paragraphs: [
              'The following items reflect current website functionality. Actual use may vary depending on login status, browser settings, and third-party services enabled.',
            ],
            table: {
              columns: ['Name', 'Purpose', 'Type', 'Retention'],
              rows: [
                ['token', 'Stores the login token used to identify signed-in users and call protected APIs.', 'localStorage', 'Until logout or browser data deletion'],
                ['language', 'Stores the Chinese or English language preference.', 'localStorage', 'Until browser data deletion'],
                ['remember_email', 'Stores the login email when the user chooses to remember it.', 'localStorage', 'Until browser data deletion or overwrite'],
                ['msg_safety_ack', 'Records that the user has read the message safety notice.', 'localStorage', 'Until browser data deletion'],
              ],
            },
          },
          {
            id: 'why',
            title: '3. Why We Use These Technologies',
            paragraphs: [
              'Essential features: keeping users signed in, calling APIs, submitting forms, uploading files, sending messages, and completing order workflows.',
              'Preferences: saving language, message safety acknowledgements, and limited page state to improve repeat visits.',
              'Security and risk control: helping detect abnormal requests, protect accounts, and handle abuse, fraud, or disputes.',
              'Analytics and improvement: if analytics are enabled, aggregated data may be used to understand page performance and visit quality.',
            ],
          },
          {
            id: 'third-party',
            title: '4. Third-Party Technologies',
            paragraphs: [
              'When you use file uploads, email, SMS, payment, hosted checkout, or cloud services, relevant service providers may set cookies or similar technologies under their own policies.',
              'If payment, analytics, or support plugins are enabled later, Oblitrok will update this policy or provide relevant notices on the website.',
            ],
          },
          {
            id: 'control',
            title: '5. How to Manage Cookies',
            paragraphs: [
              'You can delete or block cookies and local storage in your browser settings. If essential storage is blocked, login, messaging, ordering, uploads, and language preferences may stop working correctly.',
              'You may also log out and clear browser data, or clear local cache from account settings where available.',
            ],
          },
          {
            id: 'updates',
            title: '6. Updates and Contact',
            paragraphs: [
              `We may update this Cookie Policy when product features or third-party services change. For questions, contact ${CONTACT_EMAIL}.`,
            ],
          },
        ],
      },
    },
  },
};

function PolicyTable({ table }) {
  if (!table) return null;
  return (
    <div className="legal-table-wrap">
      <table className="legal-table">
        <thead>
          <tr>{table.columns.map(column => <th key={column}>{column}</th>)}</tr>
        </thead>
        <tbody>
          {table.rows.map(row => (
            <tr key={row.join('-')}>
              {row.map(cell => <td key={cell}>{cell}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function LegalPolicy({ type }) {
  const { language } = useLanguage();
  const lang = language === 'zh' ? 'zh' : 'en';
  const copy = legalCopy[lang];
  const policyType = type === 'cookie' ? 'cookie' : type === 'terms' ? 'terms' : 'privacy';
  const policy = copy.policies[policyType];
  const [otherLabel, otherUrl] = copy.otherPolicy[policyType];

  return (
    <div className="legal-page page-shell-page">
      <div className="container legal-shell">
        <aside className="legal-sidebar" aria-label={policy.title}>
          <Link to="/" className="legal-brand">Oblitrok</Link>
          <div className="legal-side-meta">
            <span>{copy.effective}</span>
            <strong>{LAST_UPDATED[lang]}</strong>
          </div>
          <nav className="legal-toc">
            {policy.sections.map(section => (
              <a href={`#${section.id}`} key={section.id}>{section.title.replace(/^\d+\.\s*/, '')}</a>
            ))}
          </nav>
          <div className="legal-contact">
            <h2>{copy.contactTitle}</h2>
            <p>{copy.contactText}</p>
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </div>
        </aside>

        <main className="legal-document">
          <header className="legal-header">
            <p>{copy.operator}: Oblitrok</p>
            <h1>{policy.title}</h1>
            <span>{copy.languageLabel} · {copy.effective}: {LAST_UPDATED[lang]}</span>
            <p>{policy.subtitle}</p>
          </header>

          {policy.sections.map(section => (
            <section className="legal-section" id={section.id} key={section.id}>
              <h2>{section.title}</h2>
              {section.paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
              <PolicyTable table={section.table} />
            </section>
          ))}

          <div className="legal-actions">
            <Link to={otherUrl}>{otherLabel}</Link>
            <Link to="/">{copy.backHome}</Link>
          </div>
        </main>
      </div>
    </div>
  );
}

export { CONTACT_EMAIL, LAST_UPDATED, legalCopy };
